import React, { useState } from "react";
import useContactForm from "../../hooks/useContactForm";

const ContactForm = () => {
    const { isSending, isSuccess, errorMessage, sendForm } = useContactForm();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        feedback: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        sendForm(formData);
    };

    return (
        <div>
            {/* Modal de Envio */}
            {isSending && (
                <div className="modal" id="sending-modal">
                    <div className="modal-content">
                        <p>Enviando...</p>
                    </div>
                </div>
            )}

            {/* Formulário de Feedback */}
            {!isSuccess && (
                <div className="feedback-form" id="contact-form">
                    <h3 className="intro-title">Entre em Contato Conosco</h3>
                    <div id="form-description">
                        <p>Preencha o formulário abaixo para saber mais sobre nosso produto e fechar uma parceria comercial conosco.</p>
                    </div>
                    <form id="feedbackForm" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="feedback-name">Nome:</label>
                            <input type="text" id="feedback-name" name="name" value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="feedback-email">Email:</label>
                            <input type="email" id="feedback-email" name="email" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="feedback-phone">Telefone:</label>
                            <input type="tel" id="feedback-phone" name="phone" value={formData.phone} onChange={handleChange} required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="feedback">Como você gostaria de utilizar o QRCode?</label>
                            <textarea id="feedback" name="feedback" rows="4" value={formData.feedback} onChange={handleChange} required></textarea>
                        </div>
                        <button type="submit" className="btn btn-primary">Enviar feedback</button>
                    </form>
                    {errorMessage && (
                        <div style={{ color: 'red' }}>
                            <p>{errorMessage}</p>
                        </div>
                    )}
                </div>
            )}

            {/* Mensagem de Sucesso */}
            {isSuccess && (
                <div id="successMessage">
                    <p>Sua mensagem foi enviada com sucesso!</p>
                    <i className="fas fa-check-circle" style={{ color: 'green', fontSize: '24px' }}></i>
                </div>
            )}
        </div>
    );
}

export default ContactForm;